export const getOptions = (index: number) => ({
  from: {
    y: -10,
  },
  to: {
    y: 0
  },
  config: {
    duration: 500
  },
  delay: (index * 100) + 500
})

export const getWrapperOptions = (height: number) => ({
  from: {
    height: 0,
    opacity: 1
  },
  to: [
    {
      height: height,
      opacity: 1,
      config: {
        duration: 400
      },
      delay: 6500
    }
  ],
  loop: {
    from: {
      height: 0,
      opacity: 1
    },
    delay: 6300
  }
})